import { LocalizationSettings } from './constants';
export const allLocales = [
    'ar-ae',
    'ar-eg',
    'ar-iq',
    'ar-ly',
    'ar-sa',
    'bg-bg',
    'bs-ba',
    'ca-es',
    'cs-cz',
    'da-dk',
    'de-at',
    'de-ch',
    'de-de',
    'de-lu',
    'el-gr',
    'en-ae',
    'en-au',
    'en-ca',
    'en-cy',
    'en-eg',
    'en-gb',
    'en-hk',
    'en-ie',
    'en-il',
    'en-in',
    'en-jo',
    'en-lb',
    'en-lk',
    'en-mt',
    'en-my',
    'en-ng',
    'en-nz',
    'en-ph',
    'en-pk',
    'en-sa',
    'en-sg',
    'en-us',
    'en-za',
    'es-ar',
    'es-bo',
    'es-cl',
    'es-co',
    'es-cr',
    'es-do',
    'es-ec',
    'es-es',
    'es-gt',
    'es-hn',
    'es-mx',
    'es-ni',
    'es-pa',
    'es-pe',
    'es-pr',
    'es-py',
    'es-sv',
    'es-uy',
    'es-ve',
    'et-ee',
    'eu-es',
    'fi-fi',
    'fr-be',
    'fr-ca',
    'fr-ch',
    'fr-dz',
    'fr-fr',
    'fr-lu',
    'fr-ma',
    'fr-tn',
    'gl-es',
    'he-il',
    'hi-in',
    'hr-hr',
    'hu-hu',
    'id-id',
    'is-is',
    'it-it',
    'ja-jp',
    'kk-kz',
    'ko-kr',
    'lt-lt',
    'lv-lv',
    'ms-my',
    'nb-no',
    'nl-be',
    'nl-nl',
    'no-no',
    'pl-pl',
    'pt-br',
    'pt-pt',
    'ro-md',
    'ro-ro',
    'ru-by',
    'ru-kz',
    'ru-ru',
    'sk-sk',
    'sl-si',
    'sr-cyrl-rs',
    'sr-latn-me',
    'sr-latn-rs',
    'sv-se',
    'th-th',
    'tr-tr',
    'uk-ua',
    'vi-vn',
    'zh-cn',
    'zh-hk',
    'zh-tw'
];
export const i18nLocales = [
    'en-US',
    'ar-SA',
    'bg-BG',
    'ca-ES',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'el-GR',
    'es-ES',
    'et-EE',
    'eu-ES',
    'fi-FI',
    'fr-FR',
    'gl-ES',
    'he-IL',
    'hi-IN',
    'hr-HR',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'kk-KZ',
    'ko-KR',
    'lt-LT',
    'lv-LV',
    'ms-MY',
    'nb-NO',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sl-SI',
    'sr-Cyrl-RS',
    'sr-Latn-RS',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'vi-VN',
    'zh-CN',
    'zh-TW'
];
export const languageToRegion = {
    ar: 'sa',
    bg: 'bg',
    cs: 'cz',
    da: 'dk',
    de: 'de',
    el: 'gr',
    en: 'us',
    es: 'es',
    et: 'ee',
    fi: 'fi',
    fr: 'fr',
    he: 'il',
    hr: 'hr',
    hu: 'hu',
    id: 'id',
    it: 'it',
    ja: 'jp',
    ko: 'kr',
    lt: 'lt',
    lv: 'lv',
    no: 'no',
    nl: 'nl',
    pl: 'pl',
    pt: 'br',
    ro: 'ro',
    ru: 'ru',
    sk: 'sk',
    sl: 'si',
    sv: 'se',
    th: 'th',
    tr: 'tr',
    uk: 'ua',
    vi: 'vn',
    zh: 'cn',
    ca: 'es',
    eu: 'es',
    gl: 'es',
    kk: 'kz',
    ms: 'my',
    hi: 'in',
    'sr-cyrl': 'rs',
    'sr-latn': 'rs'
};
export const i18nLocalesLowerCase = i18nLocales.map((locale)=>locale.toLowerCase());
export const scriptLangauges = [
    'sr-cyrl',
    'sr-latn'
];
export const languagesOnlyLocales = [
    'zh-hant',
    'zh-hans'
];
export function GetLanguageCode(locale) {
    // languageCode must only be defined if locale was valid and we could extract the right value
    let languageCode = '';
    const lowerCaseLocale = locale.toLowerCase();
    // the special cases:
    // todo: norwegian is not mapped
    if (lowerCaseLocale === 'zh-cn' || lowerCaseLocale === 'zh-hans') {
        languageCode = 'zh-Hans';
    } else if (lowerCaseLocale === 'zh-tw' || lowerCaseLocale === 'zh-hk' || lowerCaseLocale === 'zh-hant') {
        languageCode = 'zh-Hant';
    } else if (lowerCaseLocale === 'sr-cyrl') {
        languageCode = 'sr-Cyrl';
    } else if (lowerCaseLocale === 'sr-latn') {
        languageCode = 'sr-Latn';
    } else if (lowerCaseLocale === 'pt-pt') {
        languageCode = 'pt-PT';
    } else if (lowerCaseLocale === 'nb-no') {
        languageCode = 'no'; // todo: Joey to make sure this is correct mapping
    } else if (lowerCaseLocale.lastIndexOf('-') > 0) {
        languageCode = lowerCaseLocale.substring(0, lowerCaseLocale.lastIndexOf('-'));
    } else {
        // Assume that the input is the languageCode.
        // If it is not valid, it should be filtered out by the caller as appropriate.
        languageCode = lowerCaseLocale;
    }
    // GetLanguageCode will be used both by the static list of locales. And, on each request.
    return languageCode;
}
export function extractLanguageFromLocale(locale = '') {
    const loweredLocale = locale.toLowerCase();
    if (scriptLangauges.includes(loweredLocale)) {
        return loweredLocale;
    }
    const splitedLocale = loweredLocale.split('-');
    if (splitedLocale.length === 1) {
        return loweredLocale;
    }
    const languages = splitedLocale.slice(0, splitedLocale.length - 1);
    return languages.join('-');
}
export function extractRegionFromLocale(locale = '') {
    const splitedLocale = locale.split('-');
    if (splitedLocale.length === 1) {
        return '';
    }
    return splitedLocale[splitedLocale.length - 1];
}
export function getSupportedI18nLocale(locale) {
    if (i18nLocalesLowerCase.includes(locale)) {
        return locale;
    }
    const language = extractLanguageFromLocale(locale);
    const region = languageToRegion[`${language}`];
    if (region) {
        return `${language}-${region}`;
    }
    return LocalizationSettings.defaultLng;
}
function formatLanguageCode(language) {
    return language.split('-').map((lang, index)=>{
        if (index === 0) {
            return lang.toLowerCase();
        }
        return lang.charAt(0).toUpperCase() + lang.slice(1).toLowerCase();
    }).join('-');
}
export function getI18NLocale(requestLocale = '') {
    const loweredLocale = requestLocale.toLowerCase();
    if (languagesOnlyLocales.includes(loweredLocale)) {
        return formatLanguageCode(loweredLocale);
    }
    const locale = getSupportedI18nLocale(loweredLocale);
    const langauge = formatLanguageCode(extractLanguageFromLocale(locale));
    const region = extractRegionFromLocale(locale).toUpperCase();
    return [
        langauge,
        region
    ].join('-');
}
